import Icon from '../components/Icon.vue'

Icon.register({
  'shipping-fast': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 352H608V243.9C608 231.2 602.9 219 593.9 210L494 110.1C485 101.1 472.8 96 460.1 96H416V48C416 21.5 394.5 0 368 0H112C85.5 0 64 21.5 64 48V96H8C3.6 96 0 99.6 0 104V120C0 124.4 3.6 128 8 128H280C284.4 128 288 131.6 288 136V152C288 156.4 284.4 160 280 160H40C35.6 160 32 163.6 32 168V184C32 188.4 35.6 192 40 192H248C252.4 192 256 195.6 256 200V216C256 220.4 252.4 224 248 224H8C3.6 224 0 227.6 0 232V248C0 252.4 3.6 256 8 256H216C220.4 256 224 259.6 224 264V280C224 284.4 220.4 288 216 288H64V416C64 469 107 512 160 512S256 469 256 416H384C384 469 427 512 480 512S576 469 576 416H624C632.8 416 640 408.8 640 400V368C640 359.2 632.8 352 624 352zM160 464C133.5 464 112 442.5 112 416S133.5 368 160 368 208 389.5 208 416 186.5 464 160 464zM480 464C453.5 464 432 442.5 432 416S453.5 368 480 368 528 389.5 528 416 506.5 464 480 464zM560 256H416V144H460.1L560 243.9V256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shipping-fast.js
// module id = uI2s
// module chunks = 144